import waitForSatellite from './waitForSatellite';

const trackAdobeEvent = async (eventPayload) => {
  let satellite;

  try {
    satellite = await waitForSatellite();
  } catch (error) {
    console.warn(
      'Adobe satellite not available, queuing payload in digitalData:',
      error.message
    );
  }

  globalThis.digitalData = globalThis.digitalData || {};
  globalThis.digitalData.launchevents = globalThis.digitalData.launchevents || [];

  globalThis.digitalData.launchevents.push(eventPayload);

  if (satellite?.track) {
    satellite.track(eventPayload.eventName);
    satellite.logger?.log(`_satellite.track event called: ${eventPayload.eventName}`);
  }
};

export default trackAdobeEvent;
